import {
	CheckboxField,
	CheckboxGroupField,
	DateField,
	DateTimeField,
	MultiSelectField,
	SingleSelectField,
	TextField,
	TextareaField,
	TimeField,
} from "@dgs/core";
import { FC } from "react";
import { DataFieldIndexResource } from "../../../../shared/types/dataField";
import { RadioDataField } from "../../../../shared/ui/RadioDataField";

export const DataFieldEditField: FC<{ dataField: DataFieldIndexResource }> = ({ dataField }) => {
	const props = {
		label: dataField.label,
		name: dataField.id.toString(),
		placeholder: dataField.placeholder,
		description: dataField.description,
	};

	switch (dataField.type) {
		case "selectField":
			return (
				<SingleSelectField
					{...props}
					options={dataField.options}
					getLabel={(option) => option.value}
					getValue={(option) => option.id}
					clearable={true}
				/>
			);
		case "multiSelectField":
			return (
				<MultiSelectField
					{...props}
					options={dataField.options}
					getLabel={(option) => option.value}
					getValue={(option) => option.id}
					clearable={true}
				/>
			);
		case "checkboxGroup":
			return (
				<CheckboxGroupField
					{...props}
					options={dataField.options.map((x) => ({
						value: x.id,
						name: x.value,
					}))}
				/>
			);
		case "date":
			return <DateField {...props} />;
		case "time":
			return <TimeField {...props} />;
		case "dateTime":
			return <DateTimeField {...props} />;
		case "checkbox":
			return <CheckboxField {...props} />;
		case "number":
			return <TextField type="number" {...props} />;
		case "text":
			return <TextField {...props} />;
		case "email":
			return <TextField {...props} />;
		case "longText":
			return <TextareaField {...props} />;
		case "url":
			return <TextField {...props} />;
		case "radioField":
			return <RadioDataField name={dataField.id.toString()} dataField={dataField} />;
		case "phone":
			return <TextField type="tel" {...props} />;
	}
};
